import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectTemplatesService } from '../api/project-templates.service';
import { PROJECT_TEMPLATE_KEYS } from './queryKeys';

export function useProjectTemplate(templateId: string | undefined) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: PROJECT_TEMPLATE_KEYS.detail(orgId ?? '', templateId ?? ''),
    queryFn: ({ signal }) => projectTemplatesService.getById(templateId as string, signal),
    staleTime: 300_000,
    enabled: !!orgId && !!templateId,
  });

  return {
    template: data?.data,
    isLoading,
    isError,
  };
}
